import graphql from "babel-plugin-relay/macro";

const AcceptanceReportPageQuery = graphql`
  query AcceptanceReportPageQuery($after: String, $first: Int, $sort: String) {
    blocSystemDocumentTemplatesAcceptance(sort: $sort) {
      blocSystemDocumentTemplates(after: $after, first: $first) {
        totalCount
        edges {
          node {
            systemDocumentTemplate {
              pk
              status
              name
              category {
                name
              }
            }
            publishDate
            document {
              pk
              status
            }
          }
        }
      }
      buckets
      error {
        statusCode
        message
      }
    }
  }
`;

export default AcceptanceReportPageQuery;
